import styled from "styled-components";

export const AddressWrapper = styled.div`
  width: 100%;
  padding-bottom: 10rem;
  padding: 2rem;
  background-color: ${({ theme }) => theme.bg.prim_400};

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }
`;
